<template>
  <div class="modal-popup">
    <div class="modal fade" id="roomPopup" tabindex="-1" role="dialog"  aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content" v-if="room != null">
          <div class="modal-header">
            <h5 class="modal-title title" v-if="room.id != null">Odayı Güncelle ({{room.name}})</h5>
            <h5 class="modal-title title" v-else>Yeni Oda Yarat</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true" class="la la-close"></span>
            </button>
          </div>
          <div class="modal-body">
            <div class="contact-form-action">
              <form method="post" id="roomFrom">
                <div class="row">
                  <div class="col-sm-6">
                    <!--                        v-on:validate="$set(form, 'name', $event)"-->
                    <base-edit-input
                        ref="nameInput"
                        v-model="room.name"
                        :rules="'required'"
                        :type="'text'"
                        :label="'Adı'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-6">
                    <!--                        v-on:validate="$set(form, 'space', $event)"-->
                    <base-edit-input
                        ref="orderInput"
                        v-model="room.order"
                        :rules="'required'"
                        :type="'number'"
                        :label="'Sıra'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-6">
                    <base-text-area-input
                        v-model="room.description"
                        :rules="'required'"
                        :label="'Açıklama'">
                    </base-text-area-input>
                  </div>
                  <div class="col-sm-6">
                    <base-text-area-input
                        v-model="room.amenities"
                        :rules="'required'"
                        :label="'Özellikleri'">
                    </base-text-area-input>
                  </div>
                  <div class="col-sm-4">
                    <base-edit-input
                        v-model="room.maxGuestCount"
                        :rules="'required|min_value:1'"
                        :type="'number'"
                        :label="'Ziyaretçi Kapasitesi'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-4">
                    <base-edit-input
                        v-model="room.maxAdultCount"
                        :rules="'required|min_value:1'"
                        :type="'number'"
                        :label="'Yetişkin Kapasitesi'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-4">
                    <base-edit-input
                        v-model="room.code"
                        :rules="'required'"
                        :label="'Oda Kodu'">
                    </base-edit-input>
                  </div>
                  <div class="col-sm-6">
                    <base-select-input
                        v-model="room.cabinTypeId"
                        :optionList="cabinTypeList"
                        :rules="'required'"
                        :label="'Oda tipi'">
                    </base-select-input>
                  </div>
                  <div class="col-sm-6">
                    <label class="label-text">Web Sitesinde görüntüle</label>
                    <input class="form-control " style="width: 5rem;" type="checkbox" v-model="room.webVisibility">
<!--                    <base-checkbox-input-->
<!--                        v-model="room.webVisibility"-->
<!--                        :label="'Web görünürlüğü :'">-->
<!--                    </base-checkbox-input>-->
                  </div>
                  <div class="col-sm-12">
                    <base-image-edit-input
                        v-model="room.imageUrl"
                        :rules="'required'">
                    </base-image-edit-input>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="modal-footer border-top-0 pt-0">
            <button type="button" class="btn font-weight-bold font-size-15 color-text-2 mr-2" data-dismiss="modal">İptal</button>
            <button v-if="room.id != null" :class="{'disabled' : !formValid}" @click="update" type="button" class="theme-btn theme-btn-small">Güncelle</button>
            <button v-if="room.id == null" :class="{'disabled' : !formValid}" @click="create" type="button" class="theme-btn theme-btn-small">Kaydet</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UploadImage from "../../common/UploadImage";
import BaseEditInput from "../../base/BaseEditInput";
import BaseTextAreaInput from "../../base/BaseTextAreaInput";
import BaseImageEditInput from "../../base/BaseImageEditInput";
import BaseSelectInput from "../../base/BaseSelectInput";
import validationFormUtils from "../../../util/validationFormUtils";
import BaseCheckboxInput from "../../base/BaseCheckboxInput";

export default {
  name: "RoomDetail",
  components: {BaseCheckboxInput, UploadImage, BaseImageEditInput, BaseTextAreaInput, BaseEditInput, BaseSelectInput},
  data:function (){
    return{
      formValid:false
    }
  },
  computed:{
    room:{
      get(){
        return this.$store.getters.getRoom;
      }
    },
    cabinTypeList:{
      get(){
        return this.$store.getters.getCabinTypeList;
      }
    },
  },
  methods:{
    create(){
      if(this.formValid)
        this.$store.dispatch("createRoom", this.room).then(response => {
          if(response.code === 200){
              $(".modal").modal('hide')
              Swal.fire({
                icon: 'success',
                title: 'Başarılı',
                text: '',
              })
          }
        })


    },
    update(){
      if(this.formValid)
        this.$store.dispatch("updateRoom",this.room).then(response => {
          $(".modal").modal('hide')
          Swal.fire({
            icon: 'success',
            title: 'Başarılı',
            text: '',
          })
        });
    }
  },
  watch:{
    room:{
      deep:true,
      handler:function () {
         validationFormUtils.checkFormFields(this);
      }
    }
  }
}
</script>

<style scoped>

</style>